<template>
  <router-view id="page-content-wrapper"></router-view>
</template>

<script>
export default {
  name: "Document"
}
</script>

<style scoped>

</style>